import { render, staticRenderFns } from "./IconContact.vue?vue&type=template&id=4ec086d9&scoped=true"
import script from "./IconContact.vue?vue&type=script&lang=js"
export * from "./IconContact.vue?vue&type=script&lang=js"
import style0 from "./IconContact.vue?vue&type=style&index=0&id=4ec086d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec086d9",
  null
  
)

export default component.exports